<h1 mat-dialog-title>Closing {{ message }} Purchase Orders.</h1>

<div mat-dialog-content>Do you want to send POA to Amazon?</div>

<div mat-dialog-actions>
  <button class="btn-product" [mat-dialog-close]="'send'" style="margin-right: 10px; margin-left: 10px;">Close and send POA</button>
  <button class="btn-product" [mat-dialog-close]="'dontSend'" style="margin-right: 10px; margin-left: 10px;">Close without POA</button>
  <button class="btn-product" [mat-dialog-close]="'cancel'" cdkFocusInitial style="margin-right: 10px; margin-left: 10px;">Cancel</button>
</div>
